import { Transform } from 'class-transformer';
import { integerTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class ParentStudentModel {
	@Transform(integerTransformer)
	uid: number;
	name: string;
}
